import { FaRegTrashAlt } from "react-icons/fa";
export default FaRegTrashAlt